"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bulkSoftDeleteSitesApi = bulkSoftDeleteSitesApi;
exports.siteBulkAddApi = siteBulkAddApi;
exports.siteBulkAlertOffApi = siteBulkAlertOffApi;
exports.siteBulkAlertOnApi = siteBulkAlertOnApi;
exports.siteBulkApproveApi = siteBulkApproveApi;
exports.siteBulkCloneApi = siteBulkCloneApi;
exports.siteBulkDeleteApi = siteBulkDeleteApi;
exports.siteBulkGoLiveApi = siteBulkGoLiveApi;
exports.siteBulkPauseApi = siteBulkPauseApi;
exports.siteBulkPlayApi = siteBulkPlayApi;
exports.siteBulkRestrictApi = siteBulkRestrictApi;
exports.siteBulkSoftDeleteRestoreApi = siteBulkSoftDeleteRestoreApi;
exports.siteBulkSubmitApi = siteBulkSubmitApi;
exports.siteBulkUnrestrictApi = siteBulkUnrestrictApi;
var _core = require("../../../core/core.service");
var _app = _interopRequireDefault(require("../../../../configs/app.config"));
var _dashboard = require("../../../../constants/endpoints/dashboard");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// @flow

var api = new _core.APICore();

/**
 * bulk site submit
 * @param payload
 * @returns api response
 * @description this function used to bulk site submit.
 */
function siteBulkSubmitApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.SiteService.siteBulk.submit), params);
}

/**
 * bulk site approve
 * @param payload
 * @returns api response
 * @description this function used to bulk site approve.
 */
function siteBulkApproveApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.SiteService.siteBulk.approve), params);
}

/**
 * bulk add sites
 * @param payload
 * @returns api response
 * @description this function used to bulk add sites.
 */
function siteBulkAddApi(params) {
  return api.create("".concat(_app.default.baseUrl + _dashboard.SiteService.siteBulk.bulkAdd), params);
}

/**
 * bulk delete sites
 * @param payload
 * @returns api response
 * @description this function used to bulk delete multiple sites.
 */
function siteBulkDeleteApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.SiteService.siteBulk.bulkDeleted), params);
}

/**
 * go live sites
 * @param payload
 * @returns api response
 * @description this function used to go live sites.
 */
function siteBulkGoLiveApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.SiteService.siteBulk.bulkGoLive), params);
}

/**
 * play sites
 * @param payload
 * @returns api response
 * @description this function used to play sites.
 */
function siteBulkPlayApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.SiteService.siteBulk.bulkPlay), params);
}

/**
 * pause sites
 * @param payload
 * @returns api response
 * @description this function used to pause sites.
 */
function siteBulkPauseApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.SiteService.siteBulk.bulkPause), params);
}

/**
 * alert on sites
 * @param payload
 * @returns api response
 * @description this function used to alert on sites.
 */
function siteBulkAlertOnApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.SiteService.siteBulk.bulkAlertOn), params);
}

/**
 * alert off sites
 * @param payload
 * @returns api response
 * @description this function used to alert off sites.
 */
function siteBulkAlertOffApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.SiteService.siteBulk.bulkAlertOff), params);
}

/**
 * restrict sites
 * @param payload
 * @returns api response
 * @description this function used to restrict sites.
 */
function siteBulkRestrictApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.SiteService.siteBulk.bulkRestricted), params);
}

/**
 * unrestrict sites
 * @param payload
 * @returns api response
 * @description this function used to unrestrict sites.
 */
function siteBulkUnrestrictApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.SiteService.siteBulk.bulkUnrestricted), params);
}

/**
 * bulk duplicate sites
 * @param payload
 * @returns api response
 * @description this function used to bulk duplicate sites.
 */
function siteBulkCloneApi(params) {
  return api.create("".concat(_app.default.baseUrl + _dashboard.SiteService.siteBulk.bulkClone), params);
}

/**
 * bulk soft delete sites
 * @param payload
 * @returns api response
 * @description this function used to bulk soft delete sites.
 */
function bulkSoftDeleteSitesApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.SiteService.siteBulk.bulkSoftDeleteSite), params);
}

/**
 * bulk soft delete restore sites
 * @param payload
 * @returns api response
 * @description this function used to bulk soft delete restore sites.
 */
function siteBulkSoftDeleteRestoreApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.SiteService.siteBulk.bulkSoftDeleteRestore), params);
}